import { render, staticRenderFns } from "./FootLegacy.vue?vue&type=template&id=1669e062&"
import script from "./FootLegacy.vue?vue&type=script&lang=js&"
export * from "./FootLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports